import {
  polyfill,
} from 'es6-promise';
polyfill(); // Promise Polyfill for IE 11
import app from './app';

const biggerlinkArr = [
  '.biggerlink',
];

if (app.elExists(biggerlinkArr)) {
  import( /* webpackChunkName: "biggerlink" */ './components/biggerlink');
}
// Lazyload for images
if (app.elExists(['[data-echo]'])) {
  import( /* webpackChunkName: "echo" */ './components/echo');
}

const _caleandar = document.getElementById('calendar');
const _caleandar_experience_days = document.getElementById('pageExperience');

if (_caleandar && !_caleandar_experience_days) {
  import( /* webpackChunkName: "calendar" */ './components/calendar');
}

if (_caleandar_experience_days && _caleandar) {
  import( /* webpackChunkName: "calendar" */ './components/calendar_experience_days');
}

//import form validate
const formValidateArr = [
    //'form[name=entryForm]',
    'form[name=requestDocumentForm]',
    'form[name=requestForm]',
];

if (app.elExists(formValidateArr)) {
  import( /* webpackChunkName: "form-validate" */ './form-validate');
}

const formRequestStopDocument = [
  'form[name=formRequestStopDocument]'
];

if (app.elExists(formRequestStopDocument)) {
  import ( /* webpackChunkName: "form-validate" */ './form-validate');
  import ( /* webpackChunkName: "form_validate_request" */ './form_validate_request');
  import ( /* webpackChunkName: "request_stop_document" */ './request-stop-document');
}

const formRequestENDocument = [
  'form[name=formRequestENDocument]',
  'form[name=requestAbroadForm]',
];

if (app.elExists(formRequestENDocument)) {
  import ( /* webpackChunkName: "form-validate" */ './form-validate');
  import ( /* webpackChunkName: "form_validate_request" */ './form_validate_request');
}

const formRequest = [
  'form[name=requestDocumentForm]',
];

if (app.elExists(formRequest)) {
  import( /* webpackChunkName: "form-validate" */ './form-validate');
  import ( /* webpackChunkName: "form_validate_request" */ './form_validate_request');
  import( /* webpackChunkName: "request-form" */ './components/request-form');
}

const popuplinkArr = [
  '.jsCallPopupDetail',
  '.jsCallPopupDetail01',
  '.jsCallPopupDetail02',
];

if (app.elExists(popuplinkArr)) {
  import( /* webpackChunkName: "popup" */ './components/popup');
}

const isotopeArr = [
  '.btnFilterList',
];

if (app.elExists(isotopeArr)) {
  import( /* webpackChunkName: "isotope" */ './components/isotope');
}

const formEntryArr = [
  '.jsActiveTab',
  '.jsSelectOneFaculty',
  '.jsCheckedSchool',
  '.jsReset',
  '#entryForm',
];

if (app.elExists(formEntryArr)) {
  import( /* webpackChunkName: "form-entry" */ './components/form-entry');
}

const faqArr = [
  '#formSearch',
];

if (app.elExists(faqArr)) {
  import( /* webpackChunkName: "faq" */ './components/faq');
}

const requestFormArr = [
  '#search_address',
  '#search_zip',
  '.wrap-search-zip',
  '.subject_id_icon_request',
  'input[type="tel"]',
  '#search_address'
];

if (app.elExists(requestFormArr)) {
  import( /* webpackChunkName: "request-form" */ './components/request-form');
}

const markArr = [
  '.jsMark'
];

if (app.elExists(markArr)) {
  import( /* webpackChunkName: "mark" */ './components/mark');
}

const carouselCampusArr = [
  '#jsCarouselCampus'
];

if (app.elExists(carouselCampusArr)) {
  import( /* webpackChunkName: "opencampus-calendar" */ './components/opencampus-calendar');
}

const matchHeightArr = [
  '.jsMatchHeight',
  ['data-mh="*"']
];

if (app.elExists(matchHeightArr)) {
  import( /* webpackChunkName: "match-height" */ './components/match-height');
}

const scrollHintArr = [
  '.jsScrollable'
];

if (app.elExists(scrollHintArr)) {
  import( /* webpackChunkName: "scroll-hint" */ './components/scroll-hint');
}

const scrolToFixedArr = [
  '.jsFixed',
  '.jsFixedSearch',
  '.jsFixed01'
];

if (app.elExists(scrolToFixedArr)) {
  import( /* webpackChunkName: "scroll-to-fixed" */ './components/scroll-to-fixed');
}



const entryFormArr = [
  'form[name=entryFormCate1]',
  'form[name=entryFormCate2]',
  'form[name=entryFormCate3]',
  'form[name=entryFormCate4]',
  'form[name=entryFormCate5]',
  'form[name=entryFormCate7]',
  'form[name=entryFormOneDay]',
];
if (app.elExists(entryFormArr)) {
  import( /* webpackChunkName: "form-validate" */ './form-validate');
}

const entryFormCate14Arr = ['form[name=entryFormCate1]', 'form[name=entryFormCate4]'];
if (app.elExists(entryFormCate14Arr)) {
  import( /* webpackChunkName: "entry_form_cate_14" */ './entry_form/cate_14');
}

const entryFormCate2Arr = ['form[name=entryFormCate2]'];
if (app.elExists(entryFormCate2Arr)) {
  import( /* webpackChunkName: "entry_form_cate_2" */ './entry_form/cate_2');
}

const entryFormCate357Arr = [
  'form[name=entryFormCate3]',
  'form[name=entryFormCate5]',
  'form[name=entryFormCate7]'
];
if (app.elExists(entryFormCate357Arr)) {
  import( /* webpackChunkName: "entry_form_cate_357" */ './entry_form/cate_357');
}

const entryFormOneDayArr = ['form[name=entryFormOneDay]'];
if (app.elExists(entryFormOneDayArr)) {
  import( /* webpackChunkName: "entry_form_oneday" */ './entry_form/oneday');
}
